module.exports = __webpack_public_path__ + "img/secure.d5c283c2.svg";